// [S-265] "N awaiting review →" banner. Bill's gap: after uploading, docs sit
// in the Stage-3 human-review queue and never become searchable until someone
// approves them — but the queue was hard to discover. This banner surfaces the
// pending count wherever it's mounted (Studio Archive, Upload portal) and deep-
// links to the queue that turns those docs into searchable precedents.
//
// Only mount this for review-capable roles (tenant_admin / platform_admin):
// the underlying GET /review-queue requires `review:moderate`, so a tenant_user
// would get a 403. Callers gate on role before rendering. On error or an empty
// queue we render nothing (never a broken/empty banner).
import { Link } from "react-router-dom";
import { useReviewQueue } from "../data/ingestionQuery";

export function ReviewQueueBanner(): JSX.Element | null {
  const query = useReviewQueue();
  const pending = (query.data ?? []).filter((e) => e.status === "pending");
  if (query.isError || pending.length === 0) return null;
  const n = pending.length;
  return (
    <Link
      to="/queue"
      className="ingest__reviewbanner"
      data-testid="review-queue-banner"
      role="status"
    >
      <span className="ingest__reviewbanner__dot" aria-hidden="true" />
      <span className="ingest__reviewbanner__txt">
        <strong>
          {n} document{n === 1 ? "" : "s"}
        </strong>{" "}
        awaiting review — approve to make {n === 1 ? "it" : "them"} searchable.
      </span>
      <span className="ingest__reviewbanner__cta">Open review queue →</span>
    </Link>
  );
}
